import React from 'react';
import { Router } from '@reach/router';

import AppRoot from './routes/AppRoot';

const App = () => (
	<Router>
		<AppRoot default />
	</Router>
);

export default App;
